export enum ProductAndMaterialSearchStates {
    MATERIALS = 'materials',
    PRODUCTS = 'products',
}
